module.exports = __webpack_public_path__ + "static/media/25a.0d4db7c0.jpg";